<template>
  <div class="box">
    <el-button size="mini" :loading="loading" style="margin-left: 10px" type="primary" @click="confirmBox()">同步到S3</el-button>
    <el-dialog width="25%" title="同步到指定版本" :visible.sync="dialogFormVisible">
      <el-form :model="asyncForm">
        <el-form-item label="选择版本">
          <el-select v-model="asyncForm.version" placeholder="请选择">
            <el-option
              v-for="item in versionArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'SyncVersion',
  props: {
    inMethod: {
      type: Function,
      required: true
    },
    params: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      versionArr: [],
      dialogFormVisible: false,
      asyncForm: {
        version: '',
        id: '',
        type: ''
      }
    }
  },
  methods: {
    confirmBox() {
      this.getVersion()
      this.dialogFormVisible = true
    },
    onSubmit() {
      this.$confirm('此操作将同步到S3, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.dialogFormVisible = false
        if (this.params) {
          for (const i in this.params) {
            this.asyncForm[i] = this.params[i]
          }
        }
        this.inMethod(this.asyncForm).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    getVersion() {
      this.versionArr = []
      getCommonCfg({ name: 'StaticVersion' }).then(res => {
        res.data.forEach(item => {
          this.versionArr.unshift({ label: item, value: item })
        })
        if (this.versionArr.length > 0) {
          this.asyncForm.version = this.versionArr[0].value
        }
      })
    }
  }
}
</script>

<style scoped>
.box{
  display: inline-block;
}
</style>
